
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M27.314 5.086C24.292 2.064 20.274.4 16 .4S7.708 2.064 4.686 5.086C1.664 8.108 0 12.126 0 16.4s1.664 8.292 4.686 11.314C7.708 30.736 11.726 32.4 16 32.4s8.292-1.664 11.314-4.686C30.336 24.692 32 20.674 32 16.4s-1.664-8.292-4.686-11.314zM28 16.4c0 2.588-.824 4.987-2.222 6.949L9.051 6.622A11.93 11.93 0 0116 4.4c6.617 0 12 5.383 12 12zm-24 0c0-2.588.824-4.987 2.222-6.949l16.727 16.727A11.93 11.93 0 0116 28.4c-6.617 0-12-5.383-12-12z"}})])
          )
        }
      }
    